import { render, staticRenderFns } from "./HeadChallengeCard.vue?vue&type=template&id=53b6353c&"
import script from "./HeadChallengeCard.vue?vue&type=script&lang=js&"
export * from "./HeadChallengeCard.vue?vue&type=script&lang=js&"
import style0 from "./HeadChallengeCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports